import { useQuery } from '@tanstack/react-query'
import type { PartnerReferralCodes } from 'types/api'
import { apiClient } from '../../api-client'
import { SNA_PREFIX } from '../../utils'

export const partnerReferralCodesQueryKey = ['partner-referral-codes']

export function usePartnerReferralCodes() {
  async function getPartnerReferralCodes(): Promise<PartnerReferralCodes> {
    const response = await apiClient.get<PartnerReferralCodes>(
      SNA_PREFIX + 'referrals/my-codes'
    )
    return response.data
  }

  return useQuery({
    queryFn: getPartnerReferralCodes,
    queryKey: [...partnerReferralCodesQueryKey]
  })
}